module.exports = "/images/villa.svg?5c31ca6eef591f3541a1f1d1ae37005b";